import PropTypes from 'prop-types'
import { useEffect, useMemo, useState } from 'react'
import { useImmer } from 'use-immer'
import { UiCard, UiCardHeader, UiCardBody, UiDataTable } from 'components/common'
import { Heading } from '@chakra-ui/react'
import { useDebouncedCallback } from 'use-debounce'
import { format as formatDate } from 'date-fns'

export const TableOnTimeTaskCompletion = ({ data }) => {
  const [tableConfig, setTableConfig] = useImmer({
    curPage: 1,
    totalPages: 1,
    totalRecords: 0,
    itemsPerPage: 10,
    search: '',
    orderBy: {
      key: 'name',
      direction: 'asc'
    }
  })
  const [isLoading, setIsLoading] = useState(false)
  const [rows, setRows] = useState([])

  const filter = () => {
    setIsLoading(true)
    const searchedAnalytics = data.analytics.filter(v => v.projectManager.name.includes(tableConfig.search))
    const sortedAnalytics = searchedAnalytics.sort((a, b) => {
      const direction = tableConfig.orderBy.direction === 'asc' ? 1 : -1
      if (tableConfig.orderBy.key === 'name') {
        return a.projectManager.name < b.projectManager.name
          ? 1 * direction
          : (a.projectManager.name === b.projectManager.name ? 0 : -1 * direction)
      } else {
        return a.weeks[tableConfig.orderBy.key - 1].onTimeCompletionRate < b.weeks[tableConfig.orderBy.key - 1].onTimeCompletionRate
          ? 1 * direction
          : (a.weeks[tableConfig.orderBy.key - 1].onTimeCompletionRate === b.weeks[tableConfig.orderBy.key - 1].onTimeCompletionRate ? 0 : -1 * direction)
      }
    })
    const analyticsForPage = sortedAnalytics.slice((tableConfig.curPage - 1) * tableConfig.itemsPerPage, tableConfig.curPage * tableConfig.itemsPerPage)
    setRows(analyticsForPage.map(analytic => {
      return {
        pmId: analytic.projectManager.id,
        name: analytic.projectManager.name,
        rates: analytic.weeks.map(v => v.onTimeCompletionRate)
      }
    }))
    setIsLoading(false)
  }

  const debouncedFilter = useDebouncedCallback(filter, 400)

  useEffect(() => {
    debouncedFilter()
  }, [data, tableConfig.curPage, tableConfig.itemsPerPage, tableConfig.search, tableConfig.orderBy.key, tableConfig.orderBy.direction])

  useEffect(() => {
    setTableConfig(draft => {
      draft.totalRecords = data.analytics.length || 0
      draft.totalPages = Math.ceil(draft.totalRecords / draft.itemsPerPage)
    })
  }, [data])

  const TABLE_COLUMNS = useMemo(() => {
    const columns = [
      {
        label: 'User',
        orderBy: 'name',
        render: ({ name }) => name
      }
    ]
    data.dateHeaders.forEach((dateHeader, index) => {
      columns.push({
        label: formatDate(new Date(dateHeader), 'MM/dd/yyyy'),
        orderBy: `${index + 1}`,
        render: ({ rates }) => rates[index] !== 'NaN' ? `${rates[index]}%` : 'NaN'
      })
    })
    return columns
  }, [data])

  return (
    <>
      <UiCard borderRadius={0}>
        <UiCardHeader bg="gray.500" p={4}>
          <Heading color="white" size="sm">On-Time Task Completion</Heading>
        </UiCardHeader>
        <UiCardBody p={8}>
          <UiDataTable
            tableConfig={tableConfig}
            updateTableConfig={setTableConfig}
            rows={rows}
            rowKey="pmId"
            columns={TABLE_COLUMNS}
            isLoading={isLoading}
          />
        </UiCardBody>
      </UiCard>
    </>
  )
}

TableOnTimeTaskCompletion.propTypes = {
  data: PropTypes.object
}
